import { ClipboardCheck } from "lucide-react";

export function EmptyState({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="empty-state">
      <ClipboardCheck size={30} />
      <h3>{title}</h3>
      <p>{children}</p>
    </div>
  );
}
